export var EWSMessageTypeIn;
(function (EWSMessageTypeIn) {
    EWSMessageTypeIn["Pong"] = "pong";
    EWSMessageTypeIn["AuthSuccess"] = "success_auth";
    EWSMessageTypeIn["History"] = "history";
    EWSMessageTypeIn["UserMessage"] = "user_message";
    EWSMessageTypeIn["AssistantResponse"] = "assistant_response";
    EWSMessageTypeIn["AssistantResponseStatus"] = "assistant_response_status";
    EWSMessageTypeIn["NewThread"] = "new_thread";
    EWSMessageTypeIn["MessageUpdates"] = "message_updates";
    EWSMessageTypeIn["ThreadHistoryUpdate"] = "thread_history_update";
    EWSMessageTypeIn["DocumentStatusUpdate"] = "document_status_update";
    EWSMessageTypeIn["Error"] = "error";
})(EWSMessageTypeIn || (EWSMessageTypeIn = {}));
export var EWSMessageTypeOut;
(function (EWSMessageTypeOut) {
    EWSMessageTypeOut["Auth"] = "auth";
    EWSMessageTypeOut["Sync"] = "sync";
    EWSMessageTypeOut["Ping"] = "ping";
    EWSMessageTypeOut["UserMessage"] = "user_message";
    EWSMessageTypeOut["SessionState"] = "session_state";
})(EWSMessageTypeOut || (EWSMessageTypeOut = {}));
//# sourceMappingURL=ws.enum.js.map